// extracted by mini-css-extract-plugin
module.exports = {"pagination__root":"Pagination_pagination__root__1GeZh"};